export const dlContactEvent = (type) => {
    window.dataLayer.push({
        event: 'contact',
        contact: { type }
    });
};
